export default __webpack_public_path__ + "static/media/value_grey.e01e68bf.svg";